<template>
  <b-modal
    id="pos-pay-with-modal"
    :title="title"
    no-close-on-backdrop
    no-enforce-focus
    no-close-on-esc
    hide-header-close
    :ok-title="trans('pay_now')"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @ok="onPay"
  >
    <b-form-group :label="trans('amount')">
      <h3><dollar :value="amount"></dollar></h3>
    </b-form-group>

    <b-form-group v-if="!invoice.is_no_client && !noSendEmail">
      <b-form-checkbox v-model="send_email">
        {{ trans('send_confirmation_email_to').replace(':email', invoice.recipient.email) }}
      </b-form-checkbox>
    </b-form-group>
    <br v-if="invoice.is_no_client" />
  </b-modal>
</template>

<script>
  import Dollar from './../billing/Dollar'

  export default {
    props: {
      organization: Object,
      invoice: Object,
      amount: Number|String,
      title: String,
      noSendEmail: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Dollar,
    },
    data() {
      return {
        trans: trans,
        send_email: !this.invoice.is_no_client,
      }
    },
    methods: {
      onShown() {
        this.send_email = !this.invoice.is_no_client
      },
      onPay() {
        this.$emit('paying', this.send_email)
        this.$bvModal.hide('pos-pay-with-modal')
      },
    },
    mounted() {
      window.posPayWithModal = this
    },
  }
</script>